/* eslint-disable no-unused-vars */

import { DateTime } from "luxon";
import { BsPrinter } from "react-icons/bs";
import { numOrderFormat } from "../../../utils/utils";
import { FaArrowRight, FaMapMarkerAlt } from "react-icons/fa";
import { IoMdOpen } from "react-icons/io";
import { CgDanger } from 'react-icons/cg'
import { Toast } from "../../../utils/Toast";
import { api } from "../../../api/api";
import { useDispatch } from "react-redux";
import { SELECT_ORDER } from "../../../stores/reducers/OrderReducers";
import { prepareNotaPrint, sendPrintNota } from "../../../reporting/print";
import { useCompany } from "../../../hooks/useCompany";
import { useContext } from "react";
import { GlobalContext } from "../../../context/GlobalContext";
import { GrDocumentNotes } from "react-icons/gr";
import { OrderChannelIcon } from "./OrderChannelIcon";

export function Card({ order, commandCode, isMesa = false, paymentMethod, isUpdated, address, id, numOrder, name, methodDelivery, pricing, createdAt, next, selectOrder, print, status, responseWebmania, refused }) {
  const dispatch = useDispatch()
  const { configurations } = useCompany()
  const { isAccess, user } = useContext(GlobalContext)

  const date = DateTime.fromISO(createdAt).toFormat("dd/MM - HH:mm")
  const textMethodDelviery = methodDelivery === 'retirada' ? 'Retirada' : 'Entrega'

  const canceled = ['cancelado'].includes(status)

  function runCardAction(event, action) {
    event.stopPropagation()
    action()
  }

  async function sendCupom(idOrder) {
    let printPreview
    try {
      const isModuleNota = localStorage.getItem('isModuleNota')

      if (isModuleNota !== 'true') {
        return Toast.warning('O módulo de emissão de notas fiscais não está habilitado. Para ativá-lo, entre em contato com o suporte.')
      }

      Toast.success("Estamos emitindo o cupom.")

      printPreview = prepareNotaPrint(configurations.defaultCodePrint, configurations.defaultNamePrint)
      const { data } = await api.post('/nfce', { idOrder })

      await sendPrintNota({ idNota: data.idNota }, configurations.defaultCodePrint, configurations.defaultNamePrint, printPreview)

      dispatch(SELECT_ORDER({
        ...order,
        response: data
      }))

      Toast.success("Cupom emitido com sucesso.")

      document.getElementById('modalOrderClose').click()
    } catch (error) { printPreview?.previewWindow?.close() }
  }

  return (
    <div
      key={id}
      className={`order-card ${canceled ? 'order-card-canceled' : ''}`}
      onClick={selectOrder}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          selectOrder()
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={`Abrir pedido ${commandCode || numOrderFormat(numOrder)}`}
    >
      <div className="order-card-main">
        <div className="order-card-header">
          <div className="order-card-identity">
            {!isMesa && <OrderChannelIcon channel={methodDelivery === 'retirada' ? 'retirada' : 'entrega'} />}
            <div className="order-card-identity-text">
              <strong className="order-card-number">{commandCode ? commandCode : numOrderFormat(numOrder)}</strong>
              <span className="order-card-date">{date}</span>
            </div>
          </div>
          <div className="order-card-price">
            <strong>{pricing}</strong>
            <span>{paymentMethod}</span>
          </div>
        </div>

        <p className="order-card-customer">{name}</p>

        {!isMesa && (
          <div className="order-card-delivery">
            <FaMapMarkerAlt size={13} />
            <span>{textMethodDelviery === 'Retirada' ? 'Retirada no local' : address}</span>
          </div>
        )}

        <div className="order-card-actions">
          <button type="button" className="order-icon-button" title="Imprimir pedido" aria-label="Imprimir pedido" onClick={(event) => runCardAction(event, print)}>
            <BsPrinter size={16} />
          </button>

          {isAccess('fiscal', 'emissao') && status !== 'cancelado' && !order?.response && (
            <button type="button" className="order-icon-button" title="Emitir nota fiscal" aria-label="Emitir nota fiscal" onClick={(event) => runCardAction(event, () => sendCupom(order.id))}>
              <GrDocumentNotes size={16} />
            </button>
          )}

          {isUpdated && (
            <span className="order-update-alert" title="Este pedido possui novos itens">
              <CgDanger size={19} />
            </span>
          )}

          <button type="button" className="order-icon-button" title="Ver pedido" aria-label="Ver pedido" onClick={(event) => runCardAction(event, selectOrder)}>
            <IoMdOpen size={17} />
          </button>

          {next && status !== 'aguardando' && (
            <button type="button" className="order-next-button" onClick={(event) => runCardAction(event, next)}>
              Avançar <FaArrowRight size={13} />
            </button>
          )}
        </div>

        {next && status === 'aguardando' && (
          <div className="order-pending-actions">
            <button type="button" className="order-refuse-button" onClick={(event) => runCardAction(event, refused)}>Recusar</button>
            <button type="button" className="order-next-button" onClick={(event) => runCardAction(event, next)}>
              Aceitar <FaArrowRight size={13} />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
